import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const namespaced = true;

const companyModule = {
  state,
  getters,
  mutations,
  actions,
  namespaced,
};

export default companyModule;
